// App config
export const AUTH_TOKEN_KEY = "token";
export const RECENT_SEARCH_KEYWORDS = "recentSearchKeywords";
export const SAVED_FILTERS = "taskList.savedFilters";
export const SAVED_SORT = "taskList.savedSort";
export const TASK_LIST_GROUPS = "taskList.collapsedGroups";
export const SCHEDULE_SAVED_FILTERS = "schedule.savedFilters";
export const CHECKOUTS_SAVED_FILTERS = "checkouts.savedFilters";

// Feature flags
export const SHOW_REPORTS_BUTTON = "dashboard.showReportsButton";
export const ENABLE_MULTI_SELECTION = "dashboard.enableMultiSelection";
